import type { TrainingStatusAction } from "./trainingStatusActionTokens";

export type TrainingStatusMenuContext = "inProgress" | "cardValidation";

export function trainingStatusMenuActions(
  customerRowFromExternalDirectory: boolean,
  context: TrainingStatusMenuContext,
): TrainingStatusAction[] {
  if (customerRowFromExternalDirectory) {
    if (context === "cardValidation") return ["valider", "annuler"];
    return ["annuler"];
  }
  if (context === "inProgress") return ["terminer", "annuler"];
  return ["valider", "en_cours", "annuler"];
}
